import ClickOutside from './click-outside';
import Resize from './resize';
import Ripple from './ripple';
import Scroll from './scroll';
import Touch from './touch';
export { ClickOutside, Ripple, Resize, Scroll, Touch };
export default {
    ClickOutside: ClickOutside,
    Ripple: Ripple,
    Resize: Resize,
    Scroll: Scroll,
    Touch: Touch
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/lib/directives/index.js
// module id = null
// module chunks = 